/**
 * Rutas del portal accesibles sin sesión (enlaces por correo, login, etc.).
 * El interceptor HTTP no cierra sesión ni redirige a login estando en ellas (Contrato C10).
 */
const PUBLIC_ROUTE_PREFIXES: readonly string[] = [
    '/auth',
    '/revisar-documentos',
    '/diligenciar',
    '/completar-perfil',
    '/encuesta-publica',
    '/comites/firmar-acta',
    '/comites/postular',
    '/comites/votar'
];

/** Ruta sin query string ni fragmento, siempre con "/" inicial y en minúsculas. */
function normalize(url: string): string {
    const path = url.split('?')[0].split('#')[0].toLowerCase();
    return path.startsWith('/') ? path : `/${path}`;
}

function matches(path: string, prefix: string): boolean {
    return path === prefix || path.startsWith(`${prefix}/`);
}

/** `url` es la ruta del router (p. ej. `router.url`, con HashLocationStrategy ya sin el `#`). */
export function isPublicRoute(url: string): boolean {
    const path = normalize(url);
    return PUBLIC_ROUTE_PREFIXES.some(prefix => matches(path, prefix));
}

export function isAuthRoute(url: string): boolean {
    return matches(normalize(url), '/auth');
}
